"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeType = exports.FieldGroup = void 0;
var FieldGroup;
(function (FieldGroup) {
    FieldGroup["Location"] = "Location";
    FieldGroup["Authorized"] = "Authorized";
    FieldGroup["Name"] = "Name";
    FieldGroup["NCPDP"] = "NCPDP";
    FieldGroup["NPI"] = "NPI";
    FieldGroup["TaxId"] = "Tax Id";
})(FieldGroup = exports.FieldGroup || (exports.FieldGroup = {}));
var FeeType;
(function (FeeType) {
    FeeType["Percent"] = "percent";
    FeeType["FlatRate"] = "flat";
})(FeeType = exports.FeeType || (exports.FeeType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/site.ts
// module id = 3111
// module chunks = 0